export default __webpack_public_path__ + "static/media/nyc.545e4f7c.jpg";